module.exports = __webpack_public_path__ + "static/img/u957.df87245.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u957.svg
// module id = wy0a
// module chunks = 209